import { useAuthStore } from '~/stores/auth'
import { useAlertStore } from '~/stores/alert'
import { checkPendingInvites } from '~/composables/useInviteCheck'
import { ensureEventContext } from '~/composables/useEnsureEventContext'
import { useContext } from '~/composables/useContext'
const { me } = useAuth()

export default defineNuxtRouteMiddleware(async (_to, _from) => {
  await me()
  const { user, isViewer, isJudge, isSponsor, isLeader, isUser, hasEventRole, defaultUserPage } = useAuthStore()
  const alertStore = useAlertStore()
  if (isViewer)
    return true

  try {
    await ensureEventContext()
  } catch {
    // Hydration failure is non-fatal; user-scoped checks below don't need eventId.
  }

  // Users with Participant records can access the dashboard
  try {
    const result = await checkPendingInvites()
    if (result === 'pending') return navigateTo('/accept-invite')
    if (result === 'active' && !isSponsor) return true
    // Sponsors with 'active' fall through to check if they still need onboarding
  } catch {
    // Fall through to legacy checks
  }

  if (!(await isSponsor|| await isLeader || await isUser || await isJudge)) {
    alertStore.setAlert('You were redirected, because you are not authorized to view this page', 'error')
    return navigateTo(defaultUserPage)
  }

  // Judges (level 50) also satisfy isSponsor (level >= 20); send them to the
  // judge panel instead of running the sponsor onboarding checks below.
  if (isJudge)
    return navigateTo(defaultUserPage)

  if (await isSponsor) {
    // Scope onboarding checks to the current event. Without this filter a
    // returning sponsor's prior-event cart / trade profile counts as "already
    // onboarded" and they land on the dashboard instead of being routed to
    // /new-welcome to register for the new event.
    const { eventId } = useContext()
    const eid = eventId.value
    const eventCarts = (user?.carts ?? []).filter((c: any) => !eid || c?.eventId === eid)
    const eventTradeProfiles = (user?.tradeProfile ?? []).filter((p: any) =>
      (p?.Contribution ?? []).some((c: any) => !eid || c?.eventId === eid),
    )

    if (!eventCarts.length) { // No carts for this event
      if (!eventTradeProfiles.length) { // No trade profiles for this event
        return navigateTo('/new-welcome')
      }
      else {
        const firstContribution = (eventTradeProfiles[0]?.Contribution ?? [])
          .find((c: any) => !eid || c?.eventId === eid)
        if (!firstContribution?.Team?.length) { // No trade profile team yet
          return navigateTo('/new-welcome/industry-vendor')
        }
        return true
      }
    }
    if (!eventCarts.some((cart: any) => cart?.Purchase) && !eventTradeProfiles.length)
      return navigateTo('/new-welcome')
  }

  return true;
})